import { useModelApi } from '@melio/api-client';
import { ApiKeys, VexGuestW9ApiClient } from '@melio/platform-api-axios-client';

export const useCollectW9Status = (vendorId: string) =>
  useModelApi<typeof VexGuestW9ApiClient.getVexGuestW9RequestStatus>({
    queryKey: [ApiKeys.VexGuestW9Api, 'VexGuestW9RequestStatus', vendorId],
    id: vendorId,
    queryFn: () => VexGuestW9ApiClient.getVexGuestW9RequestStatus(vendorId),
  });
